import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from './../../shared/shared.service';
import { CustomValidatorsService } from './../../shared/custom-validators.service';
import { AgencyService } from '../shared/agency.service';
import { AgencyInfo, AgencyList } from '../../shared/agency.model';
import { AgentInfo, AgentList } from '../../shared/agent.model';
//import { ValidateOnBlurDirective } from './../../shared/validate-on-blur.directive';
import { Subscription } from 'rxjs/Subscription';
import { parse, format, AsYouType, isValidNumberForRegion, isValidNumber } from 'libphonenumber-js';
import { NgxSelectOptionDirective, NgxSelectComponent } from 'ngx-select-ex'
@Component({
	selector: 'app-create-agency-form',
	templateUrl: './create-agency-form.component.html',
	styleUrls: ['./create-agency-form.component.css']
})

export class CreateAgencyFormComponent implements OnInit {
	/*@Input () formType : String;*/
	@ViewChild('selectA') selectA: NgxSelectComponent;
	formType: String;
	public agencyList: Array<AgencyList>;
	public agency: AgencyInfo;
	public agent: AgentInfo;
	private sub: Subscription;
	private sub2: Subscription;
	private sub3: Subscription;
	private sub4: Subscription;
	private sub5: Subscription;
	public serviceError: string;
	public successMsg: string;
	public countries: any;
	public cities: any;
	public items: string[];
	public itemSelected: string;
	public phnCode: string;
	public phnCodeChange: any;

	viewDetails = false;
	public loggedInCountry: String;
	public loggedInCountryKey: String;
	telcodeCheck: boolean = false;
	numCheck: boolean = false;
	agencyCheck: boolean = false;
	agentCheck: boolean = false;

	cityError: boolean = false;

	cityCheck: boolean = false;
	agencycityCheck: boolean = false;
	agentcityCheck: boolean = false;

	constructor(
		private builder: FormBuilder,
		private router: Router,
		public route: ActivatedRoute,
		private sharedService: SharedService,
		private _customValidatorsService: CustomValidatorsService,
		private _agencyService: AgencyService,
		private toastr: ToastrService,
	) { }
	CreateAgencyForm: FormGroup;
	ModifyAgencyForm: FormGroup;
	ngOnInit() {
		this.sub = this.route.params.subscribe(params => {
			this.serviceError = "";
			this.successMsg = "";
			this.formType = params['formType'];
			if (this.CreateAgencyForm)
				this.resetForm();

			switch (this.formType) {
				case 'createAgency': {
					this.agency = new AgencyInfo();
					this.viewDetails = false;
					this.getCountriesAndCities();
					this.buildFormValidations();
					break;
				}
				case 'modifyAgency': {
					this.agency = new AgencyInfo(this.sharedService.getAgencyInfoDetails());
					this.agency.zipCode = this.agency.zipCode == '0' ? "" : this.agency.zipCode;
					if (this.sharedService.agencyInfo.modifyFlag)
						this.viewDetails = false;
					else
						this.viewDetails = true;
					this.telcodeCheck = true;
					this.cityCheck = false;
					var hasNumber = /\d/;
					if (hasNumber.test(this.agency.phoneCode.toString()))
						this.agency.phoneCode = '';
					this.cityCheck = true;
					this.getCountriesAndCities();
					this.buildFormValidations();
					this.sub3 = this.sharedService.getAgencyList("combo")
						.subscribe((response) => {
							this.agencyList = response;
							this.sharedService.hideMultiLoader();
							if (this.sharedService.agencyInfo.modifyFlag && (!this.agencycityCheck || !this.cityCheck)) {
								this.toastr.warning('', 'Please update city', {
									progressBar: true,
									progressAnimation: 'decreasing',
									positionClass: 'toast-top-right',
									timeOut: 3500
								});
							}

						});
					break;
				}
				case 'createAgent': {
					this.agent = new AgentInfo();
					this.agent.iataCode = this.sharedService.getAgencyInfoDetails().iatacode;

					this.viewDetails = false;
					this.getCountriesAndCities();
					this.buildFormValidations();
					break;
				}
				case 'modifyAgent': {
					this.telcodeCheck = true;
					this.cityCheck = false;
					this.agency = new AgencyInfo(this.sharedService.getAgencyInfoDetails());
					this.agency.zipCode = this.agency.zipCode == '0' ? "" : this.agency.zipCode;
					this.agent = new AgentInfo(this.sharedService.getAgentInfoDetails());
					var hasNumber = /\d/;
					if (hasNumber.test(this.agent.phoneCode.toString()))
						this.agent.phoneCode = undefined;


					for (let i in this.cities) {
						if (this.cities[i].key == this.agent.city) {
							this.cityCheck = true;
							break;
						}
					}
					if (!this.agent.city)
						this.agentcityCheck = false;
					else
						this.agentcityCheck = true;

					this.agent.travelAgentStatus = this.sharedService.getAgencyInfoDetails().travelAgentStatus;
					if (this.sharedService.agentInfo.modifyFlag)
						this.viewDetails = false;
					else
						this.viewDetails = true;

					if (!this.viewDetails && (!this.agentcityCheck || !this.cityCheck)) {
						this.toastr.warning('', 'Please update city', {
							progressBar: true,
							progressAnimation: 'decreasing',
							positionClass: 'toast-top-right',
							timeOut: 3500
						});
					}

					// if((this.agentCheck == false && this.viewDetails == true && this.telcodeCheck == false) || (this.agentCheck == true && this.numCheck == false && this.viewDetails == true && this.telcodeCheck == false)){
					// 	this.toastr.warning('', 'Please update country code', {
					// 		progressBar: true,
					// 		progressAnimation: 'decreasing',
					// 		positionClass: 'toast-top-right',
					// 		timeOut: 3500
					// 	});
					// }

					this.getCountriesAndCities();
					this.buildFormValidations();
					break;
				}
			}
		});
	}
	isValidPhoneNumber() {
		let isValidNumber = true;
		if (this.CreateAgencyForm &&
			this.CreateAgencyForm.controls &&
			this.CreateAgencyForm.controls.phone &&
			this.CreateAgencyForm.controls.phone.value &&
			this.CreateAgencyForm.controls.phoneCode &&
			this.CreateAgencyForm.controls.phoneCode.value) {
			try {
				isValidNumber = isValidNumberForRegion(this.CreateAgencyForm.controls.phone.value, this.CreateAgencyForm.controls.phoneCode.value);

			} catch (ex) {
				isValidNumber = false;
			}

		}
		else
			isValidNumber = false;
		return isValidNumber;
	}
	phoneNumberValidation(e) {
		const validationMessage = "Invalid phone number";
		let isValid = this.isValidPhoneNumber();
		if (!isValid) {
			if (this._agencyService.formErrors && this._agencyService.formErrors.phone !== undefined) {
				this._agencyService.formErrors.phone = validationMessage;
			}

			if (this.CreateAgencyForm && this.CreateAgencyForm.controls['phone']) {
				this.CreateAgencyForm.controls['phone'].setErrors({ 'inValidNumber': true });

			}
		}
		return isValid;
	}
	zeroCheck(e) {
		if (e.target.value == '' && e.keyCode == 48 && this.CreateAgencyForm.controls.phoneCode.value!='IT') {
			e.preventDefault();
		}
	}

	numericValidation(e) {
		if (!(e.keyCode >= 48 && e.keyCode <= 57)) {
			e.preventDefault();
		}
	}

	alphabetsValidation(e) {
		if (!((e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 97 && e.keyCode <= 122) || e.keyCode == 32)) {
			e.preventDefault();
		}
	}

	getCountriesAndCities() {
		this.sharedService.getCountryList().subscribe((response) => {
			this.countries = response.category[0].item;
			if (this.formType !== 'createAgency') {
				this.loggedInCountry = this.countries.find(
					cntry => cntry.key == this.agency.country).value;

			} else {
				this.loggedInCountry = this.countries.find(
					cntry => cntry.key == JSON.parse(JSON.stringify(this.sharedService.getAgencyDetails())).country).value;

			}
			//console.log(JSON.parse(localStorage.getItem("cityStoredObj")))
			this.loggedInCountryKey = this.countries.find(
				cntry => cntry.value == this.loggedInCountry).key;

			//this.sharedService.getCityList(this.loggedInCountryKey).subscribe((response) => {
			this.cities = JSON.parse(this.sharedService.getCityListData());
			this.items = ["Select"];
			this.itemSelected = "";

			for (var key in this.cities) {
				if (this.cities.hasOwnProperty(key)) {
					this.items.push(this.cities[key].value + "(" + this.cities[key].key + ")");

					if (this.formType == "modifyAgency") {
						if (this.cities[key].key == this.agency.city) {
							this.itemSelected = this.cities[key].value + " (" + this.cities[key].key + ")"
						}
					}
					else if (this.formType == "modifyAgent") {
						if (this.cities[key].key == this.agent.city) {
							this.itemSelected = this.cities[key].value + " (" + this.cities[key].key + ")"
						}
					}
				}
			}

			if (this.agency.city == '')
				this.agencycityCheck = false;
			else
				this.agencycityCheck = true;

			//});
			this.buildFormValidations();

		});


	}

	//On form submit for Create/Modify Agency/Agent
	submitForm(formDetails: any): void {
		this.serviceError = "";
		this.successMsg = "";
		for (let i in this.CreateAgencyForm.controls) {
			this.CreateAgencyForm.controls[i].markAsTouched();
		}
		let phoneFieldCheck = this.phoneNumberValidation(null);
		if (this.formType == 'createAgency' || this.formType == 'modifyAgency' || this.formType == 'createAgent' || this.formType == 'modifyAgent') {
			this.CreateAgencyForm.controls.zipCode.clearValidators()
			this.CreateAgencyForm.controls.zipCode.updateValueAndValidity()
		}
		
		if (this.CreateAgencyForm.valid) {
			formDetails.agencyStatus = formDetails.agencyStatus ? 'active' : 'inactive';
			formDetails.country = this.countries.find(
				cntry => cntry.value == this.loggedInCountry).key;
			formDetails.phoneCode = formDetails.phoneCode;
			this._agencyService.submitFormDetails(formDetails, this.formType).subscribe((response) => {
				if (response.status == 'success') {
					// if(this.sharedService.getUserRole() === 'TA_ACCMANAGE_parent') {
					// 	this.router.navigate(['/dashboard'],{queryParams: {}});
					// 	this.resetForm();
					// } else if(this.sharedService.getUserRole() === 'TA_ACCMANAGE_child') {
					// 	this.router.navigate(['/create/modifyAgency'],{queryParams: {}});
					// 	this.viewDetails = true;
					// }
					console.log(this.agency);


					if (this.formType == 'modifyAgency') {
						this.agency.firstname = formDetails.firstname;
						this.agency.lastname = formDetails.lastname;
						this.agency.email = formDetails.accountEmail;
						this.agency.address1 = formDetails.address1;
						this.agency.city = formDetails.city;
						this.agency.zipCode = formDetails.zipCode;
						this.agency.agencyName = formDetails.agencyName;
						this.agency.contact = formDetails.contactName;
						this.agency.state = formDetails.state;
						this.agency.country = formDetails.country;
						this.agency.phoneCode = formDetails.phoneCode;
						this.agency.phone = formDetails.phone;
						this.sharedService.setAgencyInfoDetails(this.agency, formDetails.iataNumber);
					}
					this.successMsg = response.message;

				} else if (response.status == 'error') {
					this.serviceError = response.message;
				}
			},
				(error) => {
					this.serviceError = JSON.parse(error.Error).message;
				});
		}
	}

	//To enable form to modify
	editable() {
		this.viewDetails = false;
		// if((this.agencyCheck == false && this.telcodeCheck == false && this.formType == 'modifyAgency') || (this.agencyCheck == true && this.numCheck == false && this.telcodeCheck == false && this.formType == 'modifyAgency')){ 
		// 	this.toastr.warning('', 'Please update country code', {
		// 		progressBar: true,
		// 		progressAnimation: 'decreasing',
		// 		positionClass: 'toast-top-right',
		// 		timeOut: 3500
		// 	});
		// }

		// if((this.agentCheck == false && this.telcodeCheck == false  && this.formType == 'modifyAgent') || (this.agentCheck == true && this.numCheck == false && this.telcodeCheck == false && this.formType == 'modifyAgent')){
		// 	this.toastr.warning('', 'Please update country code', {
		// 		progressBar: true,
		// 		progressAnimation: 'decreasing',
		// 		positionClass: 'toast-top-right',
		// 		timeOut: 3500
		// 	});
		// }


		if ((!this.agencycityCheck || !this.cityCheck) && this.formType == 'modifyAgency') {
			this.toastr.warning('', 'Please update city', {
				progressBar: true,
				progressAnimation: 'decreasing',
				positionClass: 'toast-top-right',
				timeOut: 3500
			});
		}
		if ((!this.agentcityCheck || !this.cityCheck) && this.formType == 'modifyAgent') {
			this.toastr.warning('', 'Please update city', {
				progressBar: true,
				progressAnimation: 'decreasing',
				positionClass: 'toast-top-right',
				timeOut: 3500
			});
		}
	}

	//Reactive Form Validation 
	buildFormValidations() {
		if (this.formType == 'createAgency') {
			this.CreateAgencyForm = this.builder.group({
				iataNumber: [this.agency.iatacode, [Validators.required, this._customValidatorsService.noWhitespace, this._customValidatorsService.isValidLength]],
				agencyName: [this.agency.agencyName, [Validators.required, this._customValidatorsService.noWhitespace]],
				//userName: [this.agency.userName, [Validators.required, this._customValidatorsService.noWhitespace]],
				address1: [this.agency.address1, [Validators.required, this._customValidatorsService.noWhitespace]],
				address2: [this.agency.address2],
				city: [this.agency.city, [Validators.required, this._customValidatorsService.noWhitespace]],
				state: [this.agency.state],
				zipCode: [this.agency.zipCode, [this._customValidatorsService.validZipCode]],
				country: [this.loggedInCountry],
				contactName: [this.agency.contact, [Validators.required, this._customValidatorsService.noWhitespace]],
				firstname: [this.agency.firstname, [Validators.required, this._customValidatorsService.noWhitespace]],
				lastname: [this.agency.lastname, [Validators.required, this._customValidatorsService.noWhitespace]],
				accountEmail: [this.agency.email, [Validators.required, this._customValidatorsService.isValidEmail, this._customValidatorsService.noWhitespace]],
				phone: [this.agency.phone, [Validators.required,  this._customValidatorsService.noWhitespace]],
				phoneCode: [this.agency.phoneCode, [Validators.required]],
				/*accountUserName: [this.agency.travelAgentUserName, Validators.required ],*/
				agencyStatus: [this.agency.travelAgentStatus == '1' ? true : false],
				//recieptOption: [this.agency.recieptOption]
			});

			if (this.countries != undefined && this.CreateAgencyForm.get('phoneCode').value && this.formType == 'modifyAgency') {
				this.phnCode = this.countries.find(
					cntry => cntry.key == this.CreateAgencyForm.get('phoneCode').value).meta.telephoneCode;
			}

		} else if(this.formType == 'modifyAgency'){
			this.CreateAgencyForm = this.builder.group({
				iataNumber: [this.agency.iatacode, [Validators.required, this._customValidatorsService.noWhitespace]],
				agencyName: [this.agency.agencyName, [Validators.required, this._customValidatorsService.noWhitespace]],
				//userName: [this.agency.userName, [Validators.required, this._customValidatorsService.noWhitespace]],
				address1: [this.agency.address1, [Validators.required, this._customValidatorsService.noWhitespace]],
				address2: [this.agency.address2],
				city: [this.agency.city, [Validators.required, this._customValidatorsService.noWhitespace]],
				state: [this.agency.state],
				zipCode: [this.agency.zipCode, [this._customValidatorsService.validZipCode]],
				country: [this.loggedInCountry],
				contactName: [this.agency.contact, [Validators.required, this._customValidatorsService.noWhitespace]],
				firstname: [this.agency.firstname, [Validators.required, this._customValidatorsService.noWhitespace]],
				lastname: [this.agency.lastname, [Validators.required, this._customValidatorsService.noWhitespace]],
				accountEmail: [this.agency.email, [Validators.required, this._customValidatorsService.isValidEmail, this._customValidatorsService.noWhitespace]],
				phone: [this.agency.phone, [Validators.required, this._customValidatorsService.isPhoneNumberNumeric, this._customValidatorsService.noWhitespace]],
				phoneCode: [this.agency.phoneCode, [Validators.required]],
				/*accountUserName: [this.agency.travelAgentUserName, Validators.required ],*/
				agencyStatus: [this.agency.travelAgentStatus == '1' ? true : false],
				//recieptOption: [this.agency.recieptOption]
			});

			if (this.countries != undefined && this.CreateAgencyForm.get('phoneCode').value && this.formType == 'modifyAgency') {
				this.phnCode = this.countries.find(
					cntry => cntry.key == this.CreateAgencyForm.get('phoneCode').value).meta.telephoneCode;
			}
		}else if (this.formType == 'createAgent' || this.formType == 'modifyAgent') {
			this.CreateAgencyForm = this.builder.group({
				iataNumber: [this.agent.iataCode],
				status: [this.agent.status],
				userId: [this.agent.userId],
				firstname: [this.agent.firstname, [Validators.required, this._customValidatorsService.noWhitespace]],
				lastName: [this.agent.lastName, [Validators.required, this._customValidatorsService.noWhitespace]],
				address1: [this.agent.address1, [Validators.required, this._customValidatorsService.noWhitespace]],
				address2: [this.agent.address2, [Validators.required, this._customValidatorsService.noWhitespace]],
				city: [this.agent.city, [Validators.required, this._customValidatorsService.noWhitespace]],
				state: [this.agent.state],
				country: [this.loggedInCountry],
				zipCode: [this.agent.zipCode],
				phone: [this.agent.phone, [Validators.required, this._customValidatorsService.isPhoneNumberNumeric, this._customValidatorsService.noWhitespace]],
				phoneCode: [this.agent.phoneCode, [Validators.required]],
				mobile: [this.agent.phone],
				accountEmail: [this.agent.emailId, [Validators.required, this._customValidatorsService.isValidEmail, this._customValidatorsService.noWhitespace]],
				agencyStatus: [this.agent.isUserActive]
			});
		}
		this.sub4 = this.CreateAgencyForm.valueChanges.subscribe(data => {
			this.onValueChanged(data);
		});
		this.onValueChanged();

		this.sub5 = this.CreateAgencyForm.controls['iataNumber'].valueChanges.subscribe((value) => {
			if (this.formType == 'modifyAgency' && value) {
				this.sharedService.getAgencyInfo(value).subscribe((response) => {
					this.sharedService.getAvailableCredit(value).subscribe((creditResponse) => {
						this.serviceError = "";
						this.successMsg = "";
						this.sharedService.setAgencyInfoDetails(response, value);
						this.agency = new AgencyInfo(this.sharedService.getAgencyInfoDetails());
						this.agency.creditLimit = creditResponse.availableCredit;
						this.getCountriesAndCities();
						this.buildFormValidations();
					});
				});
			}
		});
	}
	onValueChanged(data?: any) {
		if (!this.CreateAgencyForm) { return; }
		const form = this.CreateAgencyForm;
		for (const field in this._agencyService.formErrors) {
			this._agencyService.formErrors[field] = '';
			const control = form.get(field);
			if (control) {
				const messages = this._agencyService.validationMessages[field];
				if (field === 'phone' && !control.errors) {
					var isvalidphone = this.isValidPhoneNumber();
					if (!isvalidphone)
						control.setErrors({ 'inValidNumber': true });
				}
				if (field === 'city' && (control.value === 'Select' || control.value == null)) {
					control.setErrors({ 'required': true });
				}
				
				for (const key in control.errors) {
					this._agencyService.formErrors[field] += messages[key] + ' ';
					break;
				}
			}
		}
	}

	resetForm() {
		this.CreateAgencyForm.reset();
		this.serviceError = "";
		this.successMsg = "";
	}
	cancel() {
		// for (let i in this.CreateAgencyForm.controls) {
		//     this.CreateAgencyForm.controls[i].markAsUntouched();
		// }
		// if(this.formType != 'modifyAgency' && this.formType != 'modifyAgent') {
		// 	this.CreateAgencyForm.reset();
		// }
		this.router.navigate(['/dashboard'], { queryParams: {} });
	}

	ngOnDestroy() {
		if (this.sub) {
			setTimeout(() => {
				this.sub.unsubscribe();
				/*this.sub2.unsubscribe();
				this.sub3.unsubscribe();
				this.sub4.unsubscribe();
				this.sub5.unsubscribe();*/
			}, 1000);
		}
	}

	sendPwd() {
		this.serviceError = "";
		this.successMsg = "";
		this.sharedService.sendPwd(this.agent).subscribe((response) => {
			if (response.status === 'error') {
				this.serviceError = response.message;
			}
			if (response.status === 'success') {
				this.successMsg = response.message;
			}
		}, error => {
			this.serviceError = error.message;
		});
	}

	omit_special_char(event) {
		var k;
		k = event.charCode;  //         k = event.keyCode;  (Both can be used)
		return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
	}
	oncountrycodeChange(event) {
		if (event.value != '') {
			let selectedPhoneCodeCountry = event.value.split(':')[1] || '';
			if (selectedPhoneCodeCountry && selectedPhoneCodeCountry !== '') {
				let selectedPhoneCountry = this.countries.find(
					cntry => cntry.key == selectedPhoneCodeCountry.trim())
				//this.phnCodeChange = Object.assign({}, selectedPhoneCountry)
				this.phnCode = selectedPhoneCountry.meta.telephoneCode;
			}

			this.telcodeCheck = true;
		}
	}
	getPhoneCode(countryKey) {
		if (countryKey != '') {
			let selectedPhoneCountry = this.countries.find(
				cntry => cntry.key == countryKey.trim())
			//this.phnCodeChange = Object.assign({}, selectedPhoneCountry)
			return selectedPhoneCountry.meta.telephoneCode;
		}
	}
	oncityChange(event) {
		console.log(event.value);
		if (event.value != '') {
			this.cityCheck = true;
		}
	}

	oncityClose(city) {
		if (city && city !== 'Select') {
			this.cityError = false;
		} else {
			this.cityError = true;
		}
	}
	public doFocus = (currentObj) => setTimeout(() => {
		this.selectA.optionsOpen();
	});



}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/create-agency/create-agency-form/create-agency-form.component.ts